import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Playlist } from '../../types';

export type State = Playlist[];

const initialState: State = [];

export const PlaylistSlice = createSlice({
  name: 'playlists',
  initialState,
  reducers: {
    onSetPlaylist: (state, action: PayloadAction<State>) => {
      const newState = [...state];
      for (const i of action.payload) {
        const index = newState.findIndex((o) => o.uid === i.uid);
        if (index === -1) {
          newState.push(i);
        } else {
          newState[index] = i;
        }
      }
      return newState.sort((a, b) => b.created_at - a.created_at);
    },
    onDeletePlaylist: (state, action: PayloadAction<string[]>) => {
      return state.filter((s) => !action.payload.includes(s.uid));
    }
  }
});

export const { onSetPlaylist, onDeletePlaylist } = PlaylistSlice.actions;

export default PlaylistSlice.reducer;
